import StaticSelectOption from 'store/types/StaticSelectOption';

const committees: StaticSelectOption[] = [
  {
    value: 'Select Committee',
    text: 'Select Committee',
  },
  {
    value: '3D Packaging and Integration',
    text: '3D Packaging and Integration',
  },
  {
    value: 'Automated Test Equipment',
    text: 'Automated Test Equipment',
  },
  {
    value: 'Automation Technology',
    text: 'Automation Technology',
  },
  {
    value: 'Compound Semiconductor Materials',
    text: 'Compound Semiconductor Materials',
  },
  {
    value: 'EHS',
    text: 'EHS',
  },
  {
    value: 'Facilities',
    text: 'Facilities',
  },
  {
    value: 'Flexible Hybrid Electronics',
    text: 'Flexible Hybrid Electronics',
  },
  {
    value: 'FPD - Materials & Components',
    text: 'FPD - Materials & Components',
  },
  {
    value: 'FPD - Metrology',
    text: 'FPD - Metrology',
  },
  {
    value: 'Gases',
    text: 'Gases',
  },
  {
    value: 'HB-LED',
    text: 'HB-LED',
  },
  {
    value: 'Information and Control',
    text: 'Information and Control',
  },
  {
    value: 'Liquid Chemicals',
    text: 'Liquid Chemicals',
  },
  {
    value: 'MEMS - NEMS',
    text: 'MEMS - NEMS',
  },
  {
    value: 'Metrics',
    text: 'Metrics',
  },
  {
    value: 'Micropatterning',
    text: 'Micropatterning',
  },
  {
    value: 'Photovoltaic',
    text: 'Photovoltaic',
  },
  {
    value: 'Photovoltaic - Materials',
    text: 'Photovoltaic - Materials',
  },
  {
    value: 'Physical Interfaces and Carriers',
    text: 'Physical Interfaces and Carriers',
  },
  {
    value: 'Silicon Wafer',
    text: 'Silicon Wafer',
  },
  {
    value: 'Traceability',
    text: 'Traceability',
  },
];

export default committees;
